import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayoutDisplayComponent } from './payout-display.component';
import { SharedModule } from '../../../../../shared/shared.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { HoldPayoutsModalModule } from '../hold-payouts-modal/hold-payouts-modal.module';

@NgModule({
  declarations: [PayoutDisplayComponent],
  exports: [PayoutDisplayComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatSlideToggleModule,
    HoldPayoutsModalModule,
  ],
})
export class PayoutDisplayModule {}
